export default __webpack_public_path__ + "static/media/13b.90140a3a.png";